/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetProjectsProjectidSelectionsOptions, GetProjectsProjectidSelectionsResponses } from '../types/GetProjectsProjectidSelections'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /projects/:projectId/selections/}
 */
export function getProjectsProjectidSelections<ThrowOnError extends boolean = true>(options: Options<GetProjectsProjectidSelectionsOptions, ThrowOnError>): Unwrappable<RequestResult<GetProjectsProjectidSelectionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'GET', url: '/projects/{projectId}/selections/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetProjectsProjectidSelectionsResponses, ThrowOnError>>)
}
